import { Injectable } from '@angular/core';
import { ApiUxInitService } from 'src/app/services/init/api-ux-init.service';
import { ApiUxService } from 'src/app/shared/api-ux/api-ux.service';
import { RootModel } from './home.model';

@Injectable({
  providedIn: 'root'
})
export class RootService extends ApiUxInitService<RootModel>{

  constructor(apiUxService: ApiUxService) {
    super(apiUxService, 'initDrupal/root');
  }
  
}
